import Vue from "vue";
import moment from "moment"

Vue.moment = moment
Vue.prototype.$moment = moment

